import {CarouselClickHandleClick} from 'helpers-ga4';

const DirectionLock = function (Glide, Components, Events) {
  let startX, startY, lockDecided;

  return {
    mount() {
      Components.Html.wrapper.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          lockDecided = false;
        },
        {passive: true},
      );

      Components.Html.wrapper.addEventListener(
        'touchmove',
        (e) => {
          if (lockDecided) return;
          lockDecided = true;
          const dx = Math.abs(e.touches[0].clientX - startX);
          const dy = Math.abs(e.touches[0].clientY - startY);
          if (dy > dx) {
            Glide.disable();
            Components.Html.wrapper.addEventListener(
              'touchend',
              () => Glide.enable(),
              {once: true},
            );
          }
        },
        {passive: true},
      );
    },
  };
};

class Carousel extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.contentWidth = 0;
    this.resizing = false;
  }

  init() {
    const self = this;

    document
      .querySelectorAll('petivity-products-row.glide')
      .forEach((carousel) => {
        const mobileColumn = parseInt(
          carousel.getAttribute('data-mobile-columns'),
        );
        const bullets = this.querySelectorAll('.glide__bullet');
        let keyOnDots = false;
        self.contentWidth = 2000;

        let perView = self.contentWidth / 430;

        if (window.innerWidth > self.contentWidth) {
          perView = self.contentWidth / 430;
        } else if (window.innerWidth > 576 && window.innerWidth < 1025) {
          perView = window.innerWidth / 360;
        } else if (window.innerWidth > 576 && window.innerWidth < 2000) {
          perView = window.innerWidth / 430;
        }

        let options = {
          type: 'carousel',
          perView: perView,
          gap: 20,
          startAt: 0,
          breakpoints: {
            576: {
              perView: mobileColumn === 1 ? 1.2 : mobileColumn,
              gap: 20,
            },
          },
          animationDuration: 1000,
        };

        if (
          !carousel.classList.contains('glide--ltr') &&
          (window.innerWidth > 576 ||
            (window.innerWidth <= 576 && mobileColumn === 1))
        ) {
          const glide = new Glide(carousel, options);

          glide.on('resize', function (e) {
            if (!self.resizing) {
              self.resizing = true;
              self.contentWidth = 2000;
              let perView = 0;

              setTimeout(() => {
                self.resizing = false;
                if (window.innerWidth <= 576) {
                  perView = 1.2;
                } else if (window.innerWidth > self.contentWidth) {
                  perView = Number.parseFloat(self.contentWidth / 430).toFixed(
                    2,
                  );
                } else if (
                  window.innerWidth > 576 &&
                  window.innerWidth < 1025
                ) {
                  perView = Number.parseFloat(window.innerWidth / 360).toFixed(
                    2,
                  );
                } else if (
                  window.innerWidth > 576 &&
                  window.innerWidth < 2000
                ) {
                  perView = Number.parseFloat(window.innerWidth / 430).toFixed(
                    2,
                  );
                }
                if (perView > 0) glide.update({perView: perView});

                const slides = carousel.querySelectorAll('.glide__slide');

                slides.forEach((slide) => {
                  if (window.innerWidth > 1024) {
                    slide.setAttribute('role', 'group');
                  } else {
                    slide.setAttribute('role', 'tabpanel');
                  }
                });
              }, 1000);
            }
          });

          glide.on('mount.after', () => {
            const slides = carousel.querySelectorAll('.glide__slide');

            if (window.innerWidth > 1024) {
              slides.forEach((slide) => {
                slide.setAttribute('role', 'group');
              });
            }

            self.setSlideVisibility(glide.index);

            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    const srOnly = entry.target.querySelector('.sr-only');

                    setTimeout(() => {
                      entry.target.setAttribute('aria-busy', 'false');
                      slides.forEach((slide) => {
                        const item = slide.querySelector(
                          '.petivity-product-card__full-container',
                        );
                        item.classList.remove('show_placeholder');
                      });
                      observer.unobserve(entry.target);
                      if (srOnly) srOnly.textContent = 'Products loaded';
                      setTimeout(() => {
                        if (srOnly) srOnly.textContent = '';
                      }, 2000);
                    }, 500);
                  }
                });
              },
              {threshold: 0.1},
            );

            observer.observe(carousel);
          });

          glide.on('run.after', function (event) {
            const slides = carousel.querySelectorAll(
              '.glide__slide:not(.glide__slide--clone)',
            );
            const activeIndex = glide.index;
            const totalSlides = slides.length;
            const activeSlide = slides[activeIndex];
            const srOnly = carousel.querySelector('.sr-only');
            const slideTitle = activeSlide?.querySelector(
              '[data-ga4-content-type="product_row_card"]',
            );

            // Update aria-selected on bullets
            bullets.forEach((bullet, index) => {
              if (keyOnDots && index === activeIndex) {
                bullet.focus();
                keyOnDots = false;
              }
            });

            self.setSlideVisibility(glide.index);

            const slidesArray = [];
            const visibleIndexes = Array.from(
              carousel.querySelectorAll('.glide__slide[aria-hidden="false"]'),
            )
              .map((slide) => slide.dataset.itemIndex)
              .filter((i) => i > 0);

            const formattedIndexes =
              visibleIndexes.length === 1
                ? String(visibleIndexes[0])
                : visibleIndexes.slice(0, -1).join(', ') +
                  ' and ' +
                  visibleIndexes[visibleIndexes.length - 1];

            if (srOnly && window.innerWidth > 1024) {
              srOnly.textContent = `Displaying ${visibleIndexes.length === 1 ? 'slide' : 'slides'} ${formattedIndexes} of ${totalSlides}`;
              setTimeout(() => {
                srOnly.textContent = '';
              }, 2000);
            }

            if (event.direction != '=' && event.steps === 0) {
              self.ga4ArrowsNotification(
                glide,
                carousel,
                event.direction === '<' ? 'previous' : 'next',
              );
            } else if (
              event.direction != '=' &&
              typeof event.steps === 'string'
            ) {
              self.ga4ArrowsNotification(glide, carousel, 'swipe');
            }
          });

          // Announce slide changes to screen readers
          glide.on('move', () => {
            bullets.forEach((bullet, index) => {
              self.bulletAccessibility(bullet, index, glide.index);
            });
          });

          glide.mount({DirectionLock});

          bullets.forEach((bullet, index) => {
            bullet.addEventListener('keydown', (event) => {
              if (
                event.key === 'ArrowRight' ||
                event.code === 'ArrowRight' ||
                event.key === 'ArrowLeft' ||
                event.code === 'ArrowLeft'
              ) {
                keyOnDots = true;
                self.bulletAccessibility(bullet, index);
              }
            });
          });
        } else if (window.innerWidth <= 576 && mobileColumn === 2) {
          this.querySelectorAll('.glide__slide--clone').forEach((clone) => {
            clone.remove();
          });
        }
      });
  }

  enabledInteraction(item, linkElements) {
    item.setAttribute('aria-hidden', 'false');
    item.removeAttribute('tabindex');
    if (linkElements.length)
      linkElements.forEach((button) => {
        button.removeAttribute('tabindex');
        button.removeAttribute('aria-hidden');
      });
  }

  disabledInteraction(item, linkElements) {
    item.setAttribute('aria-hidden', 'true');
    if (linkElements.length) {
      item.setAttribute('tabindex', '-1');
      linkElements.forEach((button) => {
        button.setAttribute('tabindex', '-1');
        button.setAttribute('aria-hidden', 'true');
      });
    }
  }

  checkInViewPort(element) {
    const rect = element.getBoundingClientRect();
    if (
      rect.left >= 0 &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    ) {
      return element;
    }
  }

  setSlideVisibility(currentSlideIndex) {
    const slides = this.querySelectorAll(
      '.glide__slide:not(.glide__slide--clone)',
    );
    const cloneSlides = this.querySelectorAll('.glide__slide--clone');

    // Original slider
    slides.forEach((item, index) => {
      const linkElements = item.querySelectorAll(
        'a, button, input, select, textarea',
      );
      if (index === currentSlideIndex) {
        this.enabledInteraction(item, linkElements);
      } else {
        if (!this.checkInViewPort(item)) {
          this.disabledInteraction(item, linkElements);
        } else {
          this.enabledInteraction(item, linkElements);
        }
      }
    });

    // Clone slider
    cloneSlides.forEach((item) => {
      const linkElements = item.querySelectorAll(
        'a, button, input, select, textarea',
      );
      if (!this.checkInViewPort(item)) {
        this.disabledInteraction(item, linkElements);
      } else {
        this.enabledInteraction(item, linkElements);
      }
    });
  }

  bulletAccessibility(bullet, index, activeIndex) {
    bullet.setAttribute(
      'aria-selected',
      index === activeIndex ? 'true' : 'false',
    );

    bullet.setAttribute('tabindex', index === activeIndex ? '0' : '-1');
  }

  ga4ArrowsNotification(glide, carousel, direction) {
    const activeIndex = glide.index;
    const carouselTitle = carousel.querySelector(`h2.title`);
    const activeSlide = carousel.querySelector('.glide__slide--active');
    const slideAsset = activeSlide.querySelector('img');
    const item = {
      page_type: `${document.title}`,
      carousel_location: `${window.location.pathname}`,
      carousel_name: carouselTitle.textContent.trim(),
      interaction_type: 'arrow_click',
      carousel_direction: direction,
      carousel_item_index: activeIndex,
      carousel_item_label: slideAsset.getAttribute('alt'),
      item_id: activeSlide.dataset.ga4ItemId,
      item_name: activeSlide.dataset.ga4ItemName,
      carousel_type: 'product_row',
    };
    CarouselClickHandleClick(item);
  }
}
customElements.define('petivity-products-row', Carousel);